import React from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { TrashFill } from "react-bootstrap-icons";

/**
 * Dynamic CC email rows bound to Formik `cc_emails` array.
 *
 * @param {Object} props
 * @param {import('formik').FormikProps} props.formik - Parent Formik instance.
 */
const CcEmailsField = ({ formik }) => {
  const { values, errors, touched, handleChange, handleBlur, setFieldValue } =
    formik;
  const ccEmails = values.cc_emails ?? [];

  const addCcEmail = () => {
    setFieldValue("cc_emails", [...ccEmails, ""]);
  };

  const removeCcEmail = (index) => {
    const next = ccEmails.filter((_, i) => i !== index);
    setFieldValue("cc_emails", next);
  };

  return (
    <div className="mb-3">
      <Form.Label>CC recipients</Form.Label>
      <Form.Text className="d-block mb-2 text-muted">
        Internal addresses copied on each daily digest so finance knows who sent
        it.
      </Form.Text>

      {ccEmails.map((email, index) => {
        const fieldName = `cc_emails[${index}]`;
        const fieldError = errors.cc_emails?.[index];
        const fieldTouched = touched.cc_emails?.[index];

        return (
          <div
            key={index}
            className="mb-2 border border-secondary-subtle rounded p-3 d-flex gap-2 align-items-start"
          >
            <Form.Group controlId={`ccEmail${index}`} className="flex-grow-1">
              <Form.Label className="small text-muted">
                CC email {index + 1}
              </Form.Label>
              <Form.Control
                name={fieldName}
                type="email"
                value={email}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={Boolean(fieldError && fieldTouched)}
              />
              {fieldError && fieldTouched && (
                <Form.Control.Feedback type="invalid">
                  {fieldError}
                </Form.Control.Feedback>
              )}
            </Form.Group>
            <Button
              variant="outline-danger"
              className="mt-4"
              type="button"
              aria-label={`Remove CC email ${index + 1}`}
              onClick={() => removeCcEmail(index)}
            >
              <TrashFill />
            </Button>
          </div>
        );
      })}

      {typeof errors.cc_emails === "string" && (
        <div className="text-danger small mb-2">{errors.cc_emails}</div>
      )}

      <Button variant="success" type="button" onClick={addCcEmail}>
        Add CC email
      </Button>
    </div>
  );
};

export default CcEmailsField;
